export default "__VITE_ASSET__CJvNJPIB__"